/**
 * Generated by orval 🍺
 * Do not edit manually.
 * IST.Connect | v1
 * REST API backing the IST Connect web frontend. Provides endpoints to manage plugin configurations and inspect task execution results, logs, and dashboard data.
 * OpenAPI spec version: 1.0.0
 */
import type { GetPluginsParams, PluginPage } from "../model";

import { customFetch } from "../../customFetcher";

export const getGetPluginsUrl = (params?: GetPluginsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0 ? `/istconnect-service-api/plugins?${stringifiedParams}` : `/istconnect-service-api/plugins`;
};

/**
 * @summary Get basic and licence information of the plugins for a specific organisation.
 */
export const getPlugins = async (params?: GetPluginsParams, options?: Parameters<typeof customFetch>[1]): Promise<PluginPage> => {
	return customFetch<PluginPage>(getGetPluginsUrl(params), {
		...options,
		method: "GET",
	});
};
